import { Link } from 'react-router';

export function LimitationsNote() {
  return (
    <div className="rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-4 text-[12px] text-[var(--co-muted)]">
      <p className="mb-2 font-semibold text-[var(--co-text)]">How these pixels work</p>
      <ul className="list-disc space-y-1 pl-4">
        <li>
          They run inside the game iframe on your site, for your players. Promotion players and players on the Test
          Players list are excluded.
        </li>
        <li>
          Browsers that block third-party cookies — Safari, iOS, in-app browsers — limit attribution, so some
          conversions will not be matched to your ads.
        </li>
        <li>
          Meta automatic advanced matching and Event Setup Tool rules are not applied inside the game: its pages hold
          players&apos; shipping details, so only the events listed below are sent.
        </li>
        <li>
          For full attribution, listen to the iframe&apos;s postMessage events on your own page and fire your pixels
          there — see{' '}
          <Link to="/api" className="text-[var(--co-brand)] underline">
            API → Player iframe events
          </Link>
          .
        </li>
      </ul>
    </div>
  );
}
